import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ButtonManageRoles = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Button type="primary" onClick={onClick}>
      {t('button.manageRoles')}
    </Button>
  );
};

export default ButtonManageRoles;
